import {
    Autocomplete,
    Button, ButtonGroup,
    Container,
    FormControl,
    Box,
    IconButton, InputLabel, Link, MenuItem, Modal, Select,
    TextField, Tooltip,
    Typography
} from "@mui/material";
import { useAuthState } from 'react-firebase-hooks/auth';

import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import {useContext, useEffect, useRef, useState} from "react";
import axios from "axios";
import InfoIcon from "@mui/icons-material/Info";
import Page from "../../components/Page";
import LoadingBackdrop from "../../components/LoadingBackdrop";
import useSettings from "../../hooks/useSettings";
import {BASE_HOST, getAccountAPIHeader} from "../../utils/urlConst";
import QuotaModal from "./components/QuotaModal";
import 'tinymce/plugins/advlist';
  import 'tinymce/plugins/autolink';
  import 'tinymce/plugins/link';
  import 'tinymce/plugins/image';
  import 'tinymce/plugins/lists';
  import 'tinymce/plugins/charmap';
  import 'tinymce/plugins/anchor';
  import 'tinymce/plugins/searchreplace';
  import 'tinymce/plugins/wordcount';
  import 'tinymce/plugins/code';
  import 'tinymce/plugins/fullscreen';
  import 'tinymce/plugins/insertdatetime';
  import 'tinymce/plugins/media';
  import 'tinymce/plugins/nonbreaking';
  import 'tinymce/plugins/table';
  import 'tinymce/plugins/template';
  import 'tinymce/plugins/help';
import DedicatedEmailModule from "./components/DedicatedEmailModule";
import {dateRangesOverlap, getParameterByName} from "../../utils/basicUtilities";
import AdTypeToolTip from "./components/AdTypeToolTip";
import {DateRangeContext} from "./DateProvider";
import { auth } from '../../firebase';


export default function CreateAd() {

    const dateSelectorState = useContext(DateRangeContext);
      const [user] = useAuthState(auth);
    const {themeStretch} = useSettings();

    const [loadingLists, setLoadingLists] = useState(true);
    const [onLoadObject, setOnLoadObject] = useState({})
    const [editorData, setEditorData] = useState({
        "html": "",
        "design":{"counters":{"u_column":1,"u_row":1,"u_content_text":1},"body":{"id":"M4T403hXrj","rows":[{"id":"BGFm41V9ZJ","cells":[1],"columns":[{"id":"wvPS-jgg7q","contents":[{"id":"A7KB74Uko6","type":"text","values":{"containerPadding":"10px","anchor":"","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":null,"_meta":{"htmlID":"u_content_text_1","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 16px; line-height: 22.4px;\">Enter Your Ad Copy Here</span></p>"}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_1","htmlClassNames":"u_column"}}}],"values":{"displayCondition":null,"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_1","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true}}],"values":{"popupPosition":"center","popupWidth":"600px","popupHeight":"auto","borderRadius":"10px","contentAlign":"center","contentVerticalAlign":"center","contentWidth":"500px","fontFamily":{"label":"Arial","value":"arial,helvetica,sans-serif"},"textColor":"#000000","popupBackgroundColor":"#FFFFFF","popupBackgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":true},"popupOverlay_backgroundColor":"rgba(0, 0, 0, 0.1)","popupCloseButton_position":"top-right","popupCloseButton_backgroundColor":"#DDDDDD","popupCloseButton_iconColor":"#000000","popupCloseButton_borderRadius":"0px","popupCloseButton_margin":"0px","popupCloseButton_action":{"name":"close_popup","attrs":{"onClick":"document.querySelector('.u-popup-container').style.display = 'none';"}},"backgroundColor":"#ffffff","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"linkStyle":{"body":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"preheaderText":"","_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}},"schemaVersion":10}
    })
    const emailEditorRef = useRef(null);

    const [objData, setObjData] = useState({
        "name": "",
        "type": "dedicated",
        "offerId": "",
        "status": "draft",
        "quotas": [],
        "details": {},
        "created": false,
        "impressionBias": 1.0,
        "fromNames": []
    });

    const [selectableOffers, setSelectableOffers] = useState({})

    // "Preview as sent": renders the ad through the SAME GreenArrow composition
    // the send path uses (wrapper + signature + disclaimer), via the ad server.
    const [sentPreview, setSentPreview] = useState({open: false, loading: false, html: "", brand: "", brands: [], error: ""});

    function loadSentPreview(brand) {
        const adId = getParameterByName("id");
        if (!adId) return;
        setSentPreview((p) => ({...p, open: true, loading: true, error: ""}));
        user.getIdToken().then((idToken) => {
            axios.get(`${BASE_HOST}/api/basic/ads/composed-preview?id=${adId}${brand ? `&brand=${encodeURIComponent(brand)}` : ""}`, getAccountAPIHeader(idToken))
                .then((res) => {
                    setSentPreview({open: true, loading: false, html: res.data.html, brand: res.data.brand, brands: res.data.brands, error: ""});
                })
                .catch((err) => {
                    setSentPreview((p) => ({...p, loading: false, error: err?.response?.data?.message || "Preview failed"}));
                });
        });
    }
    // If QP alter useState with current ad state

    function storeEmailChanges(){
       emailEditorRef.current.editor.exportHtml((data) => {
                const {design, html} = data;
                console.log("Look here?")
                setEditorData({"html": html, "design": design});
        });
    }



    useEffect(() => {
        user.getIdToken().then((idToken) => {
          axios.get(`${BASE_HOST}/api/basic/offers?status=active`, getAccountAPIHeader(idToken))
            .then(res => {
              setSelectableOffers(res.data)

              if (getParameterByName("id") || getParameterByName("copyId")) {
                axios.get(`${BASE_HOST}/api/basic/ads?id=${getParameterByName("id") || getParameterByName("copyId")}&startDate=${dateSelectorState.dates[0].toISOString().substring(0, 10)}&endDate=${dateSelectorState.dates[1].toISOString().substring(0, 10)}`, getAccountAPIHeader(idToken))
                  .then(res => {
                    console.log("Offer Loaded");
                    console.log(res.data);


                    if (res.data.quotas) {
                      for (let i = 0; i < res.data.quotas.length; i += 1) {
                        res.data.quotas[i].startDate = new Date(res.data.quotas[i].startDate);
                        res.data.quotas[i].endDate = new Date(res.data.quotas[i].endDate);
                      }
                    }

                    setEditorData({ "html": res.data.details.html, "design": res.data.details.design })

                    delete res.data.html
                    delete res.data.design
                    if (getParameterByName("copyId")) {
                      res.data.name = `(Clone) ${res.data.name}`;
                      res.data.created = false;
                      res.data.details.created = false;
                      delete res.data.id;
                    } else {
                      res.data.created = true;
                      res.data.details.created = true;
                      // Poor Man's Deep Copy:
                      setOnLoadObject(JSON.parse(JSON.stringify(res.data))); // For Tracking Changes
                    }

                    if (!res.data.fromNames) {
                      res.data.fromNames = [];
                    }
                    setObjData(res.data);
                    setLoadingLists(false);
                    setTimeout(() => {
                      emailEditorRef.current.editor.loadDesign(res.data.details.design);

                    }, 500);

                  })

              } else {
                setLoadingLists(false);
              }


            })
        })
    }, [dateSelectorState.dates])

    const offerOptions = [];
    const offerOptionsLK = {};
    for (let i = 0; i < selectableOffers.length; i += 1) {
        const str = `${selectableOffers[i].name} ${selectableOffers[i].hasOfferId ? `( ID: ${selectableOffers[i].hasOfferId})` : ""}`;
        offerOptions.push(str);
        offerOptionsLK[selectableOffers[i].id] = str
        offerOptionsLK[str] = selectableOffers[i].id
    }

    function validateObject(){
        // pass
        //  _.isEqual
        if(objData.quotas && dateRangesOverlap(objData.quotas)){
            return "Quota Date Ranges Overlap";
        }

        if(!objData.name || objData.name.length<3){
            return "Name Is Required";
        }

        if(!objData.offerId || objData.offerId.length<4){
            return "Offer Id Is Required";
        }

        if(objData.type === "dedicated"){
            if(!objData.details.fileId || objData.details.fileId.length<1){
                return "File ID is required";
            }
            
            if(!objData.details.subjectLines || objData.details.subjectLines.length<1){
                return "At least 1 Subject Line Is Required";
            }

            for(let z=0; z<objData.details.subjectLines.length; z+=1){
                if(objData.details.subjectLines[z].length < 3){
                    return "Subject Lines Must Be At Least 4 characters"
                }
            }


            console.log("???")
            if(!editorData.html || editorData.html.indexOf("{tracking_link}") === -1){
                return "{tracking_link} must show up in creative";
            }
            
        }else{
            return "Dedicated Ad Type Is Currently Only Supported"
        }

        return true;
    }

    function serializeObject(objIn){
        const dataOut = {
            "name": objIn.name,
            "type": objIn.type,
            "offerId": objIn.offerId,
            "status": objIn.status,
            "quotas": [],
            "details": {},
            "fromNames": objIn.fromNames,
            "impressionBias": parseFloat(objIn.impressionBias)
        }

        if(objIn.quotas){
            for (let i = 0; i < objIn.quotas.length; i += 1) {
                const quotaObject = objIn.quotas[i];
                const storeObj = {
                    startDate: quotaObject.startDate,
                    endDate: quotaObject.endDate,
                };

                // eslint-disable-next-line no-restricted-syntax
                for (const z of ["click"]) {
                    if(quotaObject[`${z}MinQuota`] !== "any" && !Number.isNaN(parseInt(quotaObject[`${z}MinQuota`],10))){
                        storeObj[`${z}MinQuota`] = parseInt(quotaObject[`${z}MinQuota`],10)

                        if(quotaObject[`${z}MinQuotaBias`] !== "any" && !Number.isNaN(parseFloat(quotaObject[`${z}MinQuotaBias`]))){
                            storeObj[`${z}MinQuotaBias`] = parseFloat(quotaObject[`${z}MinQuotaBias`])
                        }else{
                            storeObj[`${z}MinQuotaBias`] = 0.0;
                        }
                    }else{
                        storeObj[`${z}MinQuota`] = "any";
                        storeObj[`${z}MinQuotaBias`] = 0.0;
                    }
                    if(quotaObject[`${z}MaxQuota`] !== "any" && !Number.isNaN(parseInt(quotaObject[`${z}MaxQuota`],10))){
                        storeObj[`${z}MaxQuota`] = parseInt(quotaObject[`${z}MaxQuota`],10);
                    }else{
                        storeObj[`${z}MaxQuota`] = "any";
                    }
                }
                dataOut.quotas.push(storeObj);
            }
        }

        if(objData.type === "dedicated" && objIn.details){
            dataOut.details.html = editorData.html;
            dataOut.details.design = editorData.design;
            dataOut.details.fileId = objIn.details.fileId;
            dataOut.details.preheader = objIn.details.preheader? objIn.details.preheader: "";
            dataOut.details.subjectLines = objIn.details.subjectLines;

            dataOut.details.disclaimer = objIn.details.disclaimer || "";
            dataOut.details.signature = objIn.details.signature || "";

        }
        
        if(objIn.id){
            dataOut.id = objIn.id;
        }

        return dataOut;
    }

    function isChange(){
        const v1 = JSON.stringify(serializeObject(objData));
        const v2 = JSON.stringify(onLoadObject);
        return v1!==v2;
    }

    const friendlyFromNames = [];
    if(objData.fromNames){
        for(let i=0;i<objData.fromNames.length; i+=1) {
            friendlyFromNames.push(
                <span style={{"display": "flex"}} id={`creative${i}`}>
                     <TextField
                         freesolo={"true"}
                         openonfocus={"true"}
                         style={{"width": "90%"}}
                         value={`${objData.fromNames[i]}`}
                         error={(objData.fromNames[i] || '').length < 2}
                         color={(objData.fromNames[i] || '').length >= 3 ? 'success' : 'error'}
                         placeholder={"Enter Name For Ad"}
                         onChange={(v) => {
                             const cre = [...objData.fromNames];
                             cre[i]=v.target.value
                             setObjData({...objData, "fromNames": cre})
                         }}
                     />

                    <IconButton aria-label="delete" onClick={() => {
                        const cre = [...objData.fromNames];
                        cre.splice(i, 1)
                        setObjData({...objData, "fromNames": cre})
                    }}>
                      <DeleteIcon/>
                    </IconButton>
               </span>
            )
        }
    }


    return <Page title="General: Create Ad">
        {loadingLists ? <LoadingBackdrop/> :

            <Container maxWidth={themeStretch ? false : 'xl'}>
                <Typography>
                    Name:
                </Typography>
                <FormControl fullWidth sx={{m: 1}}>
                    <TextField
                        id="ad-name"
                        label="Ad Name"
                        error={(objData.name || '').length < 2}
                        color={(objData.name || '').length >= 3 ? 'success' : 'error'}
                        value={objData.name || ''}
                        placeholder={"Enter Name For Ad"}
                        onChange={(v) => {
                            setObjData({...objData, name: v.target.value});
                        }}
                    />
                </FormControl>
                <Typography>
                    Offer:
                    {objData.created ?
                        <Link href={`/dashboard/offer?id=${objData.offerId}`} target="_blank">&nbsp;&nbsp;{offerOptionsLK[objData.offerId]}</Link>
                        :<div><Autocomplete
                            id={`OfferSelector`}
                            options={offerOptions}
                            value={objData.offerId ? offerOptionsLK[objData.offerId] : ""}
                            error={objData.offerId.length < 3 ? "true" : "false"}
                            color={objData.offerId.length >= 3 ? 'success' : 'error'}
                            multiple={false}
                            fullWidth
                            freesolo={"false"}
                            onChange={(event, newValue) => {
                                const supp = {...objData, offerId: offerOptionsLK[newValue]};
                                setObjData(supp);
                            }}
                            renderInput={params => <TextField {...params}
                                                              error={objData.offerId.length < 3}
                                                              color={objData.offerId.length >= 3 ? 'success' : 'error'}
                            />}
                        /></div>
                    }
                </Typography>
                                <br/><br/>
                <TextField
                    id={`impressionBias`}
                    label={`impressionBias`}
                    value={objData.impressionBias ? objData.impressionBias : 1.0}
                    inputProps={{inputMode: 'numeric', pattern: '[0-9]*'}}
                    onChange={(v) => {
                        const z = {...objData, impressionBias: v.target.value};
                        setObjData(z)
                    }}
                />
                <br/><br/>
                <InputLabel id="type-label">Ad Type</InputLabel>
                <Select
                    labelId="type-label"
                    id="type"
                    value={objData.type ? objData.type : ''}
                    label="Ad Type"
                    disabled={objData.created}
                    onChange={(e) => {
                        const z = {...objData, status: e.target.value};
                        setObjData(z)
                    }}
                >
                    <MenuItem value={"dedicated"}>Dedicated</MenuItem>
                    <MenuItem value={"space-ad"}>Space Ad</MenuItem>
                    <MenuItem value={"listicle"}>Listicle</MenuItem>
                    <MenuItem value={"push"}>Push Notification</MenuItem>
                </Select>
                <br/><br/>
                <InputLabel id="status-label">Ad Status</InputLabel>
                <Select
                    labelId="status-label"
                    id="status"
                    value={objData.status ? objData.status : ''}
                    label="Ad Status"
                    onChange={(e) => {
                        const z = {...objData, status: e.target.value};
                        setObjData(z)
                    }}
                >
                    <MenuItem value={"on"}>On</MenuItem>
                    <MenuItem value={"fixed"}>Fixed</MenuItem>
                    <MenuItem value={"off"}>Off</MenuItem>
                    <MenuItem value={"draft"}>Draft</MenuItem>
                    <MenuItem value={"archive"}>Archive</MenuItem>
                </Select>
                <AdTypeToolTip/>
                <br/><br/><br/>
                <QuotaModal quotas={objData.quotas} setQuotas={(d) => setObjData({...objData, quotas: d})}/>
                <br/><br/>
                <Typography align="left" variant={"h5"}>
                    Friendly From Names&nbsp;&nbsp;&nbsp;
                    <Tooltip style={{"marginTop": ".25em"}} title={
                        <Typography>
                            Friendly From Set an Offer Level is overridden by creative level friendly from's.<br/>
                            Supported Macros {"\"{{LIST_NAME}}\""}. Macro's must be spelled exactly as shown without quotes
                        </Typography>
                    }>
                        <IconButton>
                            <InfoIcon/>
                        </IconButton>
                    </Tooltip>

                    <IconButton aria-label="create" onClick={() => {
                        setObjData({...objData, "fromNames": ["", ...objData.fromNames]})
                    }}>
                        <AddCircleIcon color={"success"}/>
                    </IconButton>
                </Typography>
                <FormControl fullWidth sx={{m: 1}}>
                    {friendlyFromNames}
                </FormControl>
                <br/><br/>
                <DedicatedEmailModule details={objData.details} setDetails={(e)=>setObjData({...objData, details: e})} editorRef={emailEditorRef} storeChanges={()=>storeEmailChanges()} editorData={editorData}/>

                <br/> <br/><br/>
                    {getParameterByName("id") &&
                <Button variant="outlined" style={{"marginBottom": "12px"}} onClick={() => loadSentPreview("")}>
                    Preview as Sent
                </Button>}
                <Modal open={sentPreview.open} onClose={() => setSentPreview((p) => ({...p, open: false}))} style={{"overflowY": "scroll"}}>
                    <Box sx={{position: 'absolute', top: '5%', left: '50%', transform: 'translate(-50%, 0)', bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 2, width: 700, maxWidth: '95vw'}}>
                        <Typography variant="subtitle1">
                            Composed exactly as the GreenArrow send builds it (signature + disclaimer included).
                            Iterable-hosted brands render via their own templates — this is a close approximation for those.
                        </Typography>
                        {sentPreview.brands.length > 0 &&
                        <Select size="small" value={sentPreview.brand} style={{"margin": "8px 0"}}
                                onChange={(e) => loadSentPreview(e.target.value)}>
                            {sentPreview.brands.map((b) => <MenuItem key={b} value={b}>{b}</MenuItem>)}
                        </Select>}
                        {sentPreview.error && <Typography color={"error"}>{sentPreview.error}</Typography>}
                        {sentPreview.loading
                            ? <Typography>Loading…</Typography>
                            : <iframe srcDoc={sentPreview.html} sandbox="" title="Composed preview" style={{"width": "100%", "height": "70vh", "border": "1px solid #ccc"}}/>}
                    </Box>
                </Modal>

                {isChange() &&
                <div>
                    {validateObject() !== true && <Typography color={"error"} variant={"paragraph"}>Error: {validateObject()}</Typography>}
                    <br/>
                    <ButtonGroup disableElevation variant="contained" style={{"width": "25%"}}>
                    <Button size="Large" align="right" variant="contained" color="success" onClick={() => {
                        user.getIdToken(/* forceRefresh */ true).then((idToken) => {

                          if (objData.id) {
                            axios.put(`${BASE_HOST}/api/basic/ads`, serializeObject(objData), getAccountAPIHeader(idToken))
                              .then((out) => {
                                window.location.reload()
                              });
                          } else {
                            axios.post(`${BASE_HOST}/api/basic/ads`, serializeObject(objData), getAccountAPIHeader(idToken))
                              .then((out) => {
                                window.location = `${BASE_HOST}/dashboard/createAd?id=${out.data.id}`;
                              });
                          }
                        })
                    }} style={{"width": "100%"}} disabled={validateObject()!==true}>
                        Save
                    </Button>
                </ButtonGroup>
                </div>
                }
            </Container>
        }
    </Page>;
}